import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRightIcon, LockIcon, MailIcon } from 'lucide-react';
import { useApp } from '../contexts/AppContext';
import { Logo, Waves } from '../components/ui/Logo';
import { Button } from '../components/ui/Button';
import { inputClass } from '../components/ui/Field';
import { DEMO_ADMIN, DEMO_CLAN, DEMO_GOST } from '../data/members';
import type { Role } from '../types';
const profili: {
  role: Role;
  memberId: string;
  ime: string;
  opis: string;
  email: string;
}[] = [{
  role: 'clan',
  memberId: DEMO_CLAN,
  ime: 'Judita Volčanšek',
  opis: 'Članica · sopran · evidenca prisotnosti',
  email: 'jvolcansek@gmail.com'
}, {
  role: 'gost',
  memberId: DEMO_GOST,
  ime: 'Lučka Črnelič',
  opis: 'Častna članica · alt',
  email: 'luckald@yahoo.com'
}, {
  role: 'vodstvo',
  memberId: DEMO_ADMIN,
  ime: 'Krištof Strnad',
  opis: 'Zborovodja · vodstvo zbora',
  email: 'kristof.strnad@gmail.com'
}];
export function Login() {
  const {
    login,
    settings
  } = useApp();
  const navigate = useNavigate();
  const [izbran, setIzbran] = useState(0);
  const [geslo, setGeslo] = useState('••••••••');
  const [email, setEmail] = useState(profili[0].email);
  const [sporocilo, setSporocilo] = useState<string | null>(null);
  const profil = profili[izbran];
  function izberi(i: number) {
    setIzbran(i);
    setEmail(profili[i].email);
  }
  function submit(e: React.FormEvent) {
    e.preventDefault();
    login(profil.role, profil.memberId);
    navigate(profil.role === 'vodstvo' ? '/admin' : '/clan');
  }
  return <div className="flex min-h-full w-full flex-col bg-white lg:flex-row" data-id="element-1296" data-mp="3k4on75y3pcaf">
      <div className="relative flex flex-col justify-between overflow-hidden bg-green-700 px-6 py-10 lg:w-[44%] lg:px-14 lg:py-14" data-id="element-1297" data-mp="3f63m74b0yokx">
        <Waves className="absolute inset-x-0 top-1/3 h-56 w-full" color="#ffffff" opacity={0.18} data-id="element-1298" data-mp="1pshzx8rxn51r" />
        <div className="relative" data-id="element-1299" data-mp="1ktx73uf0fnnc">
          <Logo variant="dark" className="h-14 lg:h-16" data-id="element-1300" data-mp="1kuyn8davv0bx" />
        </div>
        <div className="relative mt-10 lg:mt-0" data-id="element-1301" data-mp="2aic57ufv68ws">
          <h1 className="max-w-sm text-2xl font-semibold leading-snug text-white lg:text-3xl" data-id="element-1302" data-mp="2ei30obgc5d7n">
            Interni portal zbora VIVA Brežice
          </h1>
          <p className="mt-3 max-w-sm text-[15px] leading-relaxed text-green-50/85" data-id="element-1303" data-mp="2jg4mh455bqmt">
            Vaje, nastopi, prisotnost, obvestila in gradiva — vse na enem mestu, za člane in vodstvo.
          </p>
          <p className="mt-8 text-sm italic text-green-100/80" data-id="element-1304" data-mp="2tfddpp8mmr5h">{settings.slogan}</p>
        </div>
      </div>

      <div className="flex flex-1 items-center justify-center px-6 py-12 lg:px-10" data-id="element-1305" data-mp="2xf48s556rtft">
        <div className="w-full max-w-sm" data-id="element-1306" data-mp="328paa75zn5jr">
          <h2 className="text-xl font-semibold text-ink" data-id="element-1307" data-mp="376qskpvlb0u6">Prijava</h2>
          <p className="mt-1 text-sm text-ink-muted" data-id="element-1308" data-mp="3794k4or29uwz">Vpišite se s svojim zborovskim e-naslovom.</p>

          <form onSubmit={submit} className="mt-7 space-y-4" data-id="element-1309" data-mp="3c40hm4f2hahh">
            <div data-id="element-1310" data-mp="3h5zk7c2zg3dd">
              <label htmlFor="email" className="mb-1.5 block text-[13px] font-medium text-ink" data-id="element-1311" data-mp="3h5g13s1lj8xr">
                E-naslov
              </label>
              <div className="relative" data-id="element-1312" data-mp="10j18bq39w6xc">
                <MailIcon className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-ink-muted" data-id="element-1313" data-mp="10hyhfi5ya4hf" />
                <input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} className={`${inputClass} pl-9`} data-id="element-1314" data-mp="vlrcnspaiz12" />
              </div>
            </div>

            <div data-id="element-1315" data-mp="1j9rd5kcem3su">
              <label htmlFor="geslo" className="mb-1.5 block text-[13px] font-medium text-ink" data-id="element-1316" data-mp="1jbc6j6mzfgp4">
                Geslo
              </label>
              <div className="relative" data-id="element-1317" data-mp="19jzhsnwhd6nb">
                <LockIcon className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-ink-muted" data-id="element-1318" data-mp="19j65z8inzqyb" />
                <input id="geslo" type="password" value={geslo} onChange={e => setGeslo(e.target.value)} className={`${inputClass} pl-9`} data-id="element-1319" data-mp="270ohaaxyjwtj" />
              </div>
            </div>

            <div className="flex items-center justify-between pt-1" data-id="element-1320" data-mp="1rn3w1lyo7sfq">
              <label className="flex items-center gap-2 text-[13px] text-ink-muted" data-id="element-1321" data-mp="1ct7qfutwhdw7">
                <input type="checkbox" defaultChecked className="h-4 w-4 rounded border-line accent-green-500" data-id="element-1322" data-mp="1hq7opjkidccr" />
                Ostani prijavljen
              </label>
              <button type="button" onClick={() => setSporocilo('Navodila za ponastavitev gesla smo poslali na vaš e-naslov.')} className="text-[13px] font-medium text-green-600 hover:underline" data-id="element-1323" data-mp="2afojgnvlp5c5">
                Pozabljeno geslo?
              </button>
            </div>

            {sporocilo && <p role="status" className="rounded-lg border border-green-200 bg-green-50 px-3 py-2.5 text-[13px] text-green-800" data-id="element-1324" data-mp="2oe4qyh1aezvc">
                {sporocilo}
              </p>}

            <Button type="submit" full size="lg" className="mt-2" data-id="element-1325" data-mp="csdqd42xikqq">
              Prijava
              <ArrowRightIcon className="h-4 w-4" data-id="element-1326" data-mp="rh0g7zq6muw7" />
            </Button>
          </form>

          <div className="mt-8 border-t border-line pt-6" data-id="element-1327" data-mp="ritdwpiti4s2">
            <p className="text-[11px] font-semibold uppercase tracking-wide text-ink-muted" data-id="element-1328" data-mp="mj8e6cvtpsea">
              Predstavitveni profili
            </p>
            <div className="mt-3 space-y-2" data-id="element-1329" data-mp="3pym6t688ydz4">
              {profili.map((p, i) => <button key={p.memberId} type="button" onClick={() => izberi(i)} aria-pressed={izbran === i} className={`flex w-full items-center justify-between gap-3 rounded-lg border px-3 py-2.5 text-left transition-colors duration-150 ease-out ${izbran === i ? 'border-green-300 bg-green-50' : 'border-line bg-white hover:bg-canvas'}`} data-id="element-1330" data-mp="3q0qhq84kcd8w" data-mpi={i}>
                  <span data-id="element-1331" data-mp="gu8pam7igfzr">
                    <span className="block text-sm font-medium text-ink" data-id="element-1332" data-mp="gtp3gueqp7gg">{p.ime}</span>
                    <span className="block text-xs text-ink-muted" data-id="element-1333" data-mp="ltlc56ydtn2c">{p.opis}</span>
                  </span>
                  <span className={`h-4 w-4 shrink-0 rounded-full border-[5px] ${izbran === i ? 'border-green-500 bg-white' : 'border-line bg-white'}`} data-id="element-1334" data-mp="puf183nk97wt" />
                </button>)}
            </div>
          </div>
        </div>
      </div>
    </div>;
}